import { render, staticRenderFns } from "./MainDashboard.vue?vue&type=template&id=6432cb43&"
import script from "./MainDashboard.vue?vue&type=script&lang=ts&"
export * from "./MainDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./MainDashboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports